import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component"; // Import DataTable
import { Edit, Trash2 } from "react-feather";
import axios from "axios"; // Import axios for API calls
import { baseurl } from "../../Baseurl"; // Assuming baseurl is defined
import Swal from "sweetalert2"; // Import SweetAlert2
import { Link } from "react-router-dom";

const AllBrand = () => {
  const [showModal, setShowModal] = useState(false);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState({ brandName: "", id: null }); // Manage selected brand state

  // Fetch brands from the API on component mount
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllBrands`);
        setBrands(response.data.data); // Assuming the API returns an array of brands
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    fetchBrands();
  }, []);

  // Handle Modal Open/Close
  const handleShowModal = (brand = null) => {
    setSelectedBrand(brand || { brandName: "", id: null }); // If editing, populate with brand data, else clear
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  // Handle Form Submission (Add/Update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedBrand.id) {
        // Update brand
        const response = await axios.put(`${baseurl}updateBrand`, {
          id: selectedBrand.id,
          brandName: selectedBrand.brandName,
        });
        if (response.status === 200) {
          setBrands((prev) =>
            prev.map((brand) =>
              brand.id === selectedBrand.id
                ? { ...brand, brandName: selectedBrand.brandName }
                : brand
            )
          );
          Swal.fire("Success!", "Brand updated successfully.", "success");
          handleCloseModal();
        }
      } else {
        // Add new brand
        const response = await axios.post(`${baseurl}addBrand`, {
          brandName: selectedBrand.brandName,
        });
        if (response.status === 201) {
          setBrands((prev) => [
            ...prev,
            { id: prev.length + 1, brandName: selectedBrand.brandName },
          ]);
          Swal.fire("Success!", "Brand added successfully.", "success");

          window.location.reload();
          handleCloseModal();
        }
      }
    } catch (error) {
      Swal.fire("Error!", "An error occurred while saving the brand.", "error");
      console.error("Error saving brand:", error);
    }
  };

  // Delete brand with confirmation
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This brand will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(`${baseurl}deleteBrand/${id}`);
          if (response.status === 200) {
            setBrands((prev) => prev.filter((brand) => brand.id !== id));
            Swal.fire("Deleted!", "Brand has been deleted.", "success");
          }
        } catch (error) {
          Swal.fire("Error!", "An error occurred while deleting the brand.", "error");
          console.error("Error deleting brand:", error);
        }
      }
    });
  };

  // Define columns for DataTable
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Brand Name",
      selector: (row) => row.brand_name,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <Link to={`/admin/edit-brand/${row.id}/${row.brand_name}`}
            className="btn btnedit me-2"
             
          >
            <Edit size={16} />
          </Link>
          <button
            className="btn btndelete"
            onClick={() => handleDelete(row.id)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">All Brands</h4>
            <button
              className="addbtn"
              onClick={() => handleShowModal()} // Open modal for new brand
            >
              Add Brand
            </button>
          </div>

          {/* React DataTable */}
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={brands}
              pagination
              highlightOnHover
              responsive
            />
          </div>

          {/* Bootstrap Modal */}
          {showModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              role="dialog"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {selectedBrand.id ? "Edit Brand" : "Add Brand"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleCloseModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3 text-start">
                        <label htmlFor="brandName" className="form-label">
                          Brand Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="brandName"
                          placeholder="Enter Brand Name Here.."
                          value={selectedBrand.brandName} // Bind input value to selectedBrand.brandName
                          onChange={(e) =>
                            setSelectedBrand({
                              ...selectedBrand,
                              brandName: e.target.value, // Update the brand name
                            })
                          }
                          required
                        />
                      </div>
                      <div className="text-end">
                        <button type="submit" className="btn submitbtnn">
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllBrand;
